export default "__VITE_ASSET__8e1283ea__"